// extracted by mini-css-extract-plugin
module.exports = {"icon":"x_cc","font-size-small":"x_cf","fontSizeSmall":"x_cf","font-size-default":"x_cg","fontSizeDefault":"x_cg","font-size-large":"x_ch","fontSizeLarge":"x_ch"};